<script lang="ts" setup>
import { getTypesReport } from '@/app/core/services/reports'
import { ref, onMounted } from 'vue'
import { DLoading } from 'front-library'
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { getErrorCode } from '@/app/core/composable/general'
import { useI18n } from 'vue-i18n'
import Excel from '../components/icons/Excel.vue'
import Pdf from '../components/icons/Pdf.vue'
import Txt from '../components/icons/Txt.vue'
import ExcelPdf from '../components/icons/ExcelPdf.vue'
usePayrollChange(() => window.location.reload())

/* router, notifications */
const router = useRouter()
const notifications = useNotificationsStore()
const { t } = useI18n()

/* Datos Listas */
const itemsReports = ref<any[]>([])

/* Datos componente DLoading */
const loading = ref(false)

const redirectTo = (path: string, code: string) => {
  const encodeCode = btoa(code)
  void router.push(`${path}${encodeCode}`)
}

onMounted(async () => {
  loading.value = true
  try {
    itemsReports.value = await getTypesReport(true)
    loading.value = false
  } catch (error: any) {
    loading.value = false
    const code = getErrorCode(error.response.data?.code)
    notifications.addNotification({
      title: t('error.titles.' + code),
      text: t('error.messages.' + code),
      type: 'error',
      time: 10000
    })
  }
})
</script>
<template>
  <div class="h-full px-5">
    <DLoading v-show="loading" message="" />
    <div class="bg-gray-50 sm:pb-5 lg:pb-10">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow text-blue-900"
          v-html="t('menu.internalReports')" />
      </div>
    </div>
    <form class="scroll overflow-auto h-mainReports">
      <div
        class="bg-gray-50"
        :class="[index === itemsReports.length - 1 ? '' : 'mb-10']"
        v-for="(category, index) in itemsReports"
        :key="index">
        <div class="w-full flex flex-wrap gap-3 overflow-auto py-1">
          <div
            @click="redirectTo(items.path, items.code)"
            v-for="(items, index) in category.items"
            :key="index"
            :to="items.path"
            class="flex flex-row items-center justify-between bg-white hover:bg-gray-200 rounded-lg cursor-pointer border border-gray-100">
            <div class="flex justify-center items-center gap-2 px-3 py-3">
              <Excel v-if="items.icon === 'excel'" class="h-6" />
              <Pdf v-if="items.icon === 'pdf'" class="h-6" />
              <Txt v-if="items.icon === 'txt'" class="h-6" />
              <ExcelPdf v-if="items.icon === 'pdfexcel'" class="h-6" />
              <p
                class="text-center tracking-wider text-sm font-semibold text-blue-700 max-w-xs truncate">
                {{ t(items.name) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<style scoped>
.h-mainReports {
  height: calc(100% - 8rem);
}
@media (max-width: 1023px) {
  .h-mainReports {
    height: calc(100% - 12rem);
  }
}
</style>
